import React from "react";
import {
  Drawer,
  Toolbar,
  MenuList,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import {
  makeStyles
} from "@mui/styles";
import {
  Link,
  useLocation
} from "react-router-dom";
import {useDispatch} from "react-redux";
import {fetchLogOutUser} from "../../../../store/UserStore";
import clsx from "clsx";

const SideBar = ({ menu, sideBarWidth }) => {
  const classes = useStyles();
  const match = useLocation();
  const dispatch = useDispatch();
  const [isBackdrop, setIsBackdrop] = React.useState(false);

  const handleLogOut = async () => {
    setIsBackdrop(true);
    await dispatch(fetchLogOutUser());
  };

  return (
    <>
      <Drawer
        open={true}
        className={classes.root}
        sx={{
          width: sideBarWidth,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: sideBarWidth,
            boxSizing: 'border-box',
            overflowY: "auto",
            maxHeight: "100vh",
          },
        }}
        variant="permanent"
        anchor="left"
      >
        <Toolbar sx={{ height: 80 }} />

        <div className={classes.menuContainer}>
          <MenuList className={classes.menuList}>
            {menu.map((item, index) => {
              const isActive = Boolean(
                String(item.path) === String(match.pathname) ||
                (item.path !== '/' && match.pathname.startsWith(item.path))
              );
              const iconSrc = isActive && item.IconActive ? item.IconActive : item.Icon;

              return (
              <MenuItem
                to={{ pathname: item.path, search: "" }}
                component={Link}
                key={`MenuItem-${index}`}
                className={clsx({
                  '--active': isActive,
                  '--native-icon': Boolean(item.IconActive),
                })}
              >
                <ListItemIcon>
                  <img src={iconSrc} width={20} height={20} alt="" />
                </ListItemIcon>
                <ListItemText>{item.label}</ListItemText>
              </MenuItem>
              );
            })}
          </MenuList>

          <MenuList className={classes.menuList}>
            <MenuItem onClick={handleLogOut}>
              <ListItemIcon>
                <img src={require('../../../../assets/svg/sidebar/logout.svg').default} width={20} height={20} alt="" />
              </ListItemIcon>
              <ListItemText>Выход</ListItemText>
            </MenuItem>
          </MenuList>
        </div>
      </Drawer>

      <Backdrop open={isBackdrop}>
        <CircularProgress />
      </Backdrop>
    </>
  );
};

const useStyles = makeStyles(() => ({
  root: {
    flexShrink: 0,
    "& .MuiPaper-root": {
      zIndex: 999,
      border: "none !important",
      borderRight: "1px solid #E4E4E7 !important",
      background: "#FAFAFA",
    }
  },
  menuContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "100%",
    paddingTop: 20,
  },
  menuList: {
    padding: 0,

    "& .MuiMenuItem-root": {
      padding: "12px 12px 12px 20px",
      gap: 12,
      boxSizing: "border-box",
      textDecoration: "none",

      "&.--active": {
        background: "#EDE9FE",
        "& .MuiListItemText-primary": {
          color: "#4F39F6",
        },
        "&:not(.--native-icon) .MuiListItemIcon-root img": {
          filter: "invert(22%) sepia(96%) saturate(5765%) hue-rotate(249deg) brightness(97%) contrast(97%)",
        },
      },
      "&.--native-icon .MuiListItemIcon-root img": {
        filter: "none",
      },
      "&:hover:not(.--active)": {
        background: "#F4F4F5",
      },
    },
    "& .MuiListItemIcon-root": {
      minWidth: 20,
      width: 20,
      height: 20,
      "& img": {
        filter: "invert(32%) sepia(7%) saturate(1103%) hue-rotate(201deg) brightness(95%) contrast(89%)",
      },
    },
    "& .MuiMenuItem-root.--native-icon .MuiListItemIcon-root img": {
      filter: "none",
    },
    "& .MuiListItemText-primary": {
      fontSize: 14,
      color: "#52525B",
      fontWeight: 500,
      lineHeight: "20px",
    },
  },
}));

export default SideBar;
